module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contratos/modal-nuevo-convenio/detalles-convenio/detalles-convenio.component.scss
// module id = ./src/app/components/contratos/modal-nuevo-convenio/detalles-convenio/detalles-convenio.component.scss
// module chunks = main